<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    isReadonly: {
      type: Boolean,
      default: () => false,
    },
  },

  data: () => ({
    isLoading: false,

    isValid: false,
  }),
  computed: {
    ...mapGetters("admin-contract2023", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,
  },
  methods: {
    ...mapActions("admin-contract2023", [
      "SET_APPLICATION",
      "SAVE_APPLICATION",
    ]),

    onChangeApp() {
      this.$nextTick(() => {
        this.SET_APPLICATION(this.application);
      });
    },

    onSend() {
      this.isValid = true;
      this.$refs.form.validate();
      this.$nextTick(() => {
        const el = document.querySelector(".error--text");

        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          this.SAVE_APPLICATION(this.application).then((status) => {
            if (status) {
              window.location.reload();
            }
          });
        }
      });
    },
  },
};
</script>

<template>
  <v-form
    :readonly="isReadonly"
    @submit.prevent="() => false"
    ref="form"
    lazy-validation
  >
    <div class="section-header">1. {{ $t("Group Number") }}</div>
    <div class="py-13 px-6">
      <v-row>
        <v-col cols="12" md="4">
          <div>
            <div class="form-label">
              {{ $t("Add Group Number") }} <span v-text="'*'" />
            </div>

            <v-text-field
              autofocus
              autocomplete="off"
              @blur="onChangeApp"
              v-model="application.groupCode"
              dense
              outlined
              required
              :rules="[$rules.required, $rules.groupnumber]"
              v-inputmask="$masks.groupnumber"
            />
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="row">
      <div align="center" class="col-12">
        <v-btn :disabled="isReadonly" @click="onSend" color="accent">
          {{ $t("Save") }}
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<style lang="scss" scoped>
.section-header {
  background: rgb(0, 150, 219);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.25em;
  color: white;
  padding: 5px;
}

.form-label {
  font-weight: 500;
  margin-bottom: 8px;

  span {
    padding-left: 2px;
    color: red;
  }
}

.review-msg {
  position: absolute;
  top: -26px;
}
</style>
